export default __webpack_public_path__ + "static/orrprotection-defa51f9aba6ffec2cc85a37e75fd57c.svg";